import { FlexContainer } from './FlexContainer';
import { Box, Typography, useTheme } from '@mui/material';

export interface Information {
  label: string;
  value: string;
}

interface InformationViewProps {
  information: Information[];
  title?: string;
}

export const InformationView = ({
  information,
  title,
}: InformationViewProps) => {
  const theme = useTheme();

  return (
    <FlexContainer
      direction="column"
      gap={2}
      padding={2}
      borderRadius="lessRounded"
      backgroundColor={theme.palette.navyShades[50]}
      overflow="visible"
    >
      {title && <Typography variant="subheadMedium">{title}</Typography>}
      {information.map(info => (
        <Box key={`${info.label}-${info.value}`}>
          <Typography variant="labelMedium" display="block">
            {info.label}
          </Typography>
          <Typography variant="bodyLarge" display="block">
            {info.value}
          </Typography>
        </Box>
      ))}
    </FlexContainer>
  );
};
